import React from "react";
import * as Ri from "react-icons/ri";

export const Sidebar = [
  /*{
    title: "Search",
    path: "/reports",
    icon: <AiIcons.AiOutlineSearch />,
    cName: "nav-text",
  },*/
  {
    title: "Create blog",
    path: "/products",
    icon: <Ri.RiAddCircleFill />,
    cName: "nav-text",
  },
];
